import { Beech } from './beech';

const SOFT_IDLE_SECONDS = 900; // 15 min  → IDLE  (stays in overflow pool)
const HARD_AWAY_SECONDS = 3600; // 1 hour  → AWAY  (excluded entirely)
const POLL_INTERVAL_MS = 60_000;

export default class AutoAway {
	private beech: Beech;
	private timer: number | null = null;
	private weSetState = false;
	private isLocked = false;

	constructor(beech: Beech) {
		this.beech = beech;
	}

	public start = (): void => {
		if (this.timer !== null) return;
		if (this.beech.embedded.isEnabled()) return;
		if (!window.electronAPI?.isElectron) return;
		this.timer = window.setInterval(this.tick, POLL_INTERVAL_MS);
		window.electronAPI.onLockScreen?.(this.handleLock);
		window.electronAPI.onUnlockScreen?.(this.handleUnlock);
	};

	private tick = async (): Promise<void> => {
		if (this.beech.model.getAgentFlow() !== 'IDLE') return;
		const idleSeconds = await window.electronAPI!.getSystemIdleTime();
		if (this.beech.model.getAgentFlow() !== 'IDLE') return;
		this.apply(idleSeconds);
	};

	// All branches below stay synchronous so the agentFlow re-check above remains valid.
	private apply = (idleSeconds: number): void => {
		const headset = this.beech.model.getHeadsetState();
		const target =
			this.isLocked || idleSeconds >= HARD_AWAY_SECONDS
				? 'AWAY'
				: idleSeconds >= SOFT_IDLE_SECONDS
					? 'IDLE'
					: 'AVAILABLE';

		if (headset === target) return;

		if (target === 'AVAILABLE') {
			if (this.weSetState) {
				this.beech.model.setHeadsetState('AVAILABLE');
				this.weSetState = false;
			}
			return;
		}

		const canPromote = headset === 'AVAILABLE' || (headset === 'IDLE' && target === 'AWAY');
		if (canPromote) {
			this.beech.model.setHeadsetState(target);
			this.weSetState = true;
		}
	};

	private handleLock = (): void => {
		this.isLocked = true;
		if (this.beech.model.getAgentFlow() === 'IDLE') {
			this.apply(Number.MAX_SAFE_INTEGER);
		}
	};

	private handleUnlock = (): void => {
		this.isLocked = false;
		this.tick();
	};
}
